// extracted by mini-css-extract-plugin
export default {"main":"pageNotFound_main__izRZj","text":"pageNotFound_text__8vzpi"};